module.exports = __webpack_public_path__ + "static/media/AdditionsItemCalloutsExample@2x.45f49070b94706f0f471d3ea7148ecde.jpg";